import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

import { PrimaryButton, colors } from '@crehana/ui';

import { Message } from '@crehana/icons';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import { ChatNode } from 'Jsx/CrehanaLive/graphql/types/ChatNode';
import { ChatActions } from 'Jsx/CrehanaLive/hooks/useChatActions';

import MessageCard from './Chat/components/MessageCard';

interface QuestionsProps extends ChatActions {
  questions: ChatNode[];
  error: boolean;
  refetch: () => void;
  areActionsEnabled?: boolean;
  hasModeratorPermission: boolean;
  isLoggedIn: boolean;
  goToChat: () => void;
}

const Questions: React.FC<QuestionsProps> = ({
  questions,
  error,
  refetch,
  areActionsEnabled,
  hasModeratorPermission,
  isLoggedIn,
  goToChat,
  setMessageAsQuestion,
  likeLiveQuestion,
  likedMessages,
}) => {
  const { t } = useCrehanaLiveTranslations();

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full p-16">
        <p className="font-body3 text-white">{t('UPS_ERROR_LIVE_LABEL')}</p>
        <br />
        <PrimaryButton
          label="Intentar de nuevo"
          onClick={() => refetch()}
          darkMode
        />
      </div>
    );
  }

  if (!questions.length) {
    return (
      <div className="flex flex-col items-center justify-center h-full p-40 text-center">
        <Message size={48} className="mb-16" color={colors.baseLighter} />
        <p className="font-h4 mb-8 text-white">
          {t('NOT_QUESTIONS_LIVE_LABEL')}
        </p>
        <p className="mb-24 break-words font-body3 text-white">
          {hasModeratorPermission
            ? t('SEARCH_QUESTIONS_LIVE_LABEL')
            : t('SOON_QUESTIONS_LIVE_LABEL')}
        </p>
        <PrimaryButton label="Ir al chat" onClick={goToChat} darkMode />
      </div>
    );
  }

  return (
    <Scrollbars>
      <div className="px-24 py-8 overflow-y-auto">
        {questions.map(question => (
          <MessageCard
            {...question}
            key={question.originalId!}
            areActionsEnabled={areActionsEnabled}
            hasModeratorPermission={hasModeratorPermission}
            isLoggedIn={isLoggedIn}
            setMessageAsQuestion={setMessageAsQuestion}
            likeLiveQuestion={likeLiveQuestion}
            likedMessages={likedMessages}
          />
        ))}
      </div>
    </Scrollbars>
  );
};

export default Questions;
